import React from "react";
import "./index.scss";
import { getIcon, CloseIcon } from "./messageData";

const Message = ({
  type = "info",
  children,
  bordered = true,
  showIcon = false,
  closable = false,
  onClose,
  className = "",
  ...props
}) => {
  const IconComponent = getIcon(type);

  return (
    <div
      className={`message message-${type} ${
        !bordered ? "no-border" : ""
      } ${className}`}
      {...props}
    >
      {showIcon && (
        <div className="message-icon">
          <IconComponent />
        </div>
      )}
      <div className="message-content">{children}</div>
      {closable && (
        <button
          className="message-close-btn"
          onClick={onClose}
          aria-label="Close message"
        >
          <CloseIcon />
        </button>
      )}
    </div>
  );
};

export default Message;
